/** 문서 안의 셀 요소 셀렉터. jsdom 엔 CSS.escape 가 없어 따옴표·역슬래시만 손으로 이스케이프한다 */
export const cellSelector = (cellId: string) =>
  `[data-cell-id="${globalThis.CSS?.escape?.(cellId) ?? cellId.replace(/["\\]/g, "\\$&")}"]`;
